import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, usd } from "../lib/api";
import Navbar from "../components/Navbar";
import { Heart, Clock, CheckCircle2 } from "lucide-react";

export default function SponsorshipConfirmation() {
  const { reference } = useParams();
  const [sp, setSp] = useState(null);
  useEffect(() => { api.get(`/sponsorships/${reference}`).then(({ data }) => setSp(data)).catch(() => {}); }, [reference]);
  if (!sp) return <div><Navbar /><div className="max-w-xl mx-auto px-4 py-24 text-center text-slate-500">Loading...</div></div>;
  const pending = sp.payment_status !== "paid" && sp.payment_method === "bank";
  const b = sp.bank_details;
  return (
    <div><Navbar />
      <div className="max-w-2xl mx-auto px-4 py-12">
        <div className="rounded-2xl bg-white border border-[#E2EBF0] shadow-xl overflow-hidden" data-testid="sponsorship-confirmation">
          <div className={`p-6 text-white ${sp.payment_status === "paid" ? "bg-[#008057]" : "bg-[#03281B]"}`}>
            <div className="text-[10px] uppercase tracking-widest text-[#F3C242] font-bold">Sponsorship Reference</div>
            <div className="font-display text-3xl font-extrabold flex items-center gap-3">{sp.reference} <Heart size={26} className="text-[#F3C242]" /></div>
            <div className="mt-2 inline-flex items-center gap-1 text-sm">{sp.payment_status === "paid" ? <CheckCircle2 size={16} /> : <Clock size={16} />} {sp.payment_status === "paid" ? "Confirmed - Thank you!" : "Pending Payment"}</div>
          </div>
          <div className="p-6 space-y-4">
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div><span className="text-slate-500">Children sponsored</span><div className="font-bold">{sp.quantity}</div></div>
              <div><span className="text-slate-500">Total</span><div className="font-bold">{usd(sp.total)}</div></div>
              <div><span className="text-slate-500">Package</span><div data-testid="sponsorship-package" className="font-bold">{sp.package ? `${sp.package.quantity} x ${sp.package.name}` : sp.category?.name}</div></div>
              <div><span className="text-slate-500">VIP dinner seats</span><div className="font-bold">{sp.vip_seats}</div></div>
            </div>
            {pending && (
              <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm">
                <div className="font-bold text-amber-800 mb-1">Complete your bank transfer ({usd(sp.total)})</div>
                <div>Bank: <b>{b.bank}</b> &middot; Acct: <b className="font-mono">{b.account_number}</b> &middot; ACH: <b className="font-mono">{b.routing_ach}</b> &middot; Wire: <b className="font-mono">{b.routing_wire}</b></div>
                <div className="text-xs text-amber-700 mt-1">Include reference {sp.reference} in your transfer.</div>
              </div>
            )}
            <p className="text-sm text-slate-600">Thank you for supporting a young player! We'll be in touch about your commemorative scarf, VIP dinner seats and closing celebration on June 13, 2027.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
